import styled from 'styled-components';

const StyledCilentHeaders = styled.div`
padding: 1rem 0px;
.cilent-logo{
  width: auto;
  height: 65px;
  padding-right: 2rem;
}
.brand-logo{
  width: auto;
  height: 90px;
  padding-left: 2rem;
}
@media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
  .cilent-logo{
    height: 35px;
    padding-right: 1rem;
  }
  .brand-logo{
    height: 50px;
    padding-left: 1rem;
  }
};
`;

export default StyledCilentHeaders;



// WEBPACK FOOTER //
// client/containers/GiftCard/StyledCilentHeaders.js